import { styled } from '../../../stitches.config';

export const ButtonGroup = styled('div', {
  display: 'flex',
  variants: {
    direction: {
      row: {
        '& button:first-child:not(:last-child)': {
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        },
        '& button:not(:first-child)': {
          borderLeft: 0,
        },
        '& button:not(:first-child):not(:last-child)': {
          borderRadius: 0,
        },
        '& button:not(:first-child):last-child': {
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        },
      },
      column: {
        'flexDirection': 'column',
        '& button:first-child:not(:last-child)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
        '& button:not(:first-child)': {
          borderTop: 0,
        },
        '& button:not(:first-child):not(:last-child)': {
          borderRadius: 0,
        },
        '& button:not(:first-child):last-child': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
      },
    },
  },
  defaultVariants: {
    direction: 'row',
  },
});
